import { isAuth } from '@/services/PermissionService';
import Content from '@/components/layout/Content';
import Names from './names';
import { hasPermission, MANAGER, OWNER, POS_VIEW_BUSINESS_REVIEWS, SUPER_ADMIN } from '@/middlewares/permissions';

export default {
	path: '/orders',
	component: Content,
	children: [
		{
			path: '/orders',
			redirect: '/orders/list',
		},
		{
			path: 'kanban',
			name: Names.OrdersKanban,
			component: () => import('../views/orders/Kanban'),
			meta: {
				title: 'Kanban',
				middleware: [isAuth],
			},
		},
		{
			path: 'list',
			name: Names.OrdersList,
			component: () => import('../views/orders/List'),
			meta: {
				title: 'Orders List',
				middleware: [isAuth],
			},
		},
		{
			path: 'reviews',
			name: Names.OrdersReviews,
			component: () => import('../views/orders/Reviews'),
			meta: {
				title: 'Reviews',
				middleware: [
					isAuth,
					(nav) => hasPermission(nav, [POS_VIEW_BUSINESS_REVIEWS], [SUPER_ADMIN, OWNER, MANAGER]),
				],
			},
		},
		{
			path: 'create/:businessId',
			name: Names.CreateOrder,
			component: () => import('../views/orders/Create'),
			meta: {
				title: 'Create Order',
				middleware: [isAuth],
			},
		},
		{
			path: ':id',
			name: Names.OrderDetails,
			component: () => import('../views/orders/Details'),
			meta: {
				title: 'Order Details',
				middleware: [isAuth],
			},
		},
	],
};
